export default "__VITE_ASSET__aUSlk0xf__"